// mui
import { Button, useTheme } from "@mui/material"

export default function ActionButton({variant = 'filled', children, onClick, disabled, sx, icon = null, iconPosition = 'start'}) {
  const theme = useTheme();
  const isFilled = variant === 'filled';

  const baseStyle = {
    height: {xs: '2.3rem', md: '2.5rem'},
    fontSize: '0.875rem',
    lineHeight: 'normal',
    borderRadius: '10px',
    textTransform: 'none',
    color: 'black',
    border: `2px solid ${theme.palette.rgd.primary}`,
    padding: '8px 24px',    

    backgroundColor: isFilled ? 'rgd.primary' : 'transparent',
    color: isFilled ? 'rgd.backgroundPage' : 'rgd.primary',
    fontWeight: '600',

    // Добавляем gap между иконкой и текстом
    gap: '8px',
  
    // Удаляем margin у startIcon
    '& .MuiButton-startIcon': {
      margin: 0,
      color: 'inherit'
    },
    
    // Удаляем margin у endIcon
    '& .MuiButton-endIcon': {
      margin: 0,
      color: 'inherit'
    },
    '&:hover': {
      backgroundColor: isFilled ? 'transparent' : 'rgd.primary',
      color: isFilled ? 'rgd.primary' : 'rgd.backgroundPage',
      transition: 'all .15s ease-in-out',
      transitionDuration: '250ms'
    },
    '&:focus': {
      outline: 'none',
      backgroundColor: isFilled ? 'transparent' : 'rgd.primary',
      color: isFilled ? 'rgd.primary' : 'rgd.backgroundPage',
      transition: 'all .15s ease-in-out',
      transitionDuration: '250ms'
    },
    '&::after': {
      boxShadow: 'none',
    },
    '&.Mui-disabled': {
      backgroundColor: isFilled ? 'rgd.primary' : 'rgd.backgroundPage',
      opacity: '55%',
      color: isFilled ? 'rgd.backgroundPage' : 'rgd.primary',
      cursor: 'not-allowed',
    },
  }

  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      fullWidth
      sx={[baseStyle, sx]}
      startIcon={icon && iconPosition === 'start' ? icon : null}
      endIcon={icon && iconPosition === 'end' ? icon : null}
    >
      {children}
    </Button>
  )
} 